<div class="message-details-page jhm-page" [class.mobile]="isMobile">
	@if (isMobile) {
		<div class="jhm-top-toolbar jhm-mobile-top-toolbar">
			<div class="left">
				<div class="back">
					<button (click)="goToPreviousPage()">
						<img src="./assets/images/arrow-left.svg">
					</button>
				</div>
			</div>
			<div class="right">
				<button class="jhm-icon-button transparent"><i class="fa-light fa-trash" (click)="delete()"></i></button>
				<button class="jhm-icon-button transparent reply"><i class="fa-solid fa-paper-plane-top" (click)="reply()"></i></button>
			</div>
		</div>
	}
	@else {
		<div class="jhm-top-toolbar">
			<div class="left">
				<div class="back">
				<button (click)="goToPreviousPage()">
					<img src="./assets/images/arrow-left.svg">
				</button>
				</div>
				<div class="navigation-item" [class.focus]="selectedPage ==='MESSAGE'">
					<button (click)="switchPage('MESSAGE')">Message</button>
				</div>
			</div>
			<div class="right">
                @if (!messageDetails?.senderHasBeenReleased) {
                    <button class="action jhm-button reply" (click)="reply()">Reply</button>
                }
				<button class="action jhm-button"><img src="./assets/images/printer.svg"> Print</button>
			</div>
		</div>
	}
	@if (messageDetails) {
		<div class="content-wrapper message">
		@if (selectedPage ==='MESSAGE') {
			<div class="subject"><span [innerHTML]="messageDetails.subject"></span></div>
			<div class="date">{{getTimeString()}}</div>
			<div class="users">
				<div class="user word-selection">
					<span class="vertically-centered-label">From:</span> <span class="word" [ngClass]="messageDetails.senderType.toLowerCase()">{{messageDetails.senderFullName}}</span>
				</div>
				<div class="user word-selection">
					<span class="vertically-centered-label">To:</span> <span class="word" [ngClass]="messageDetails.recipientType.toLowerCase()">{{messageDetails.recipientFullName ? messageDetails.recipientFullName: messageDetails.pendingUsername}}</span>
				</div>
			</div>
			<hr class="form-divider" />
			<div class="body-and-photos">
				<div class="message-body">
					<span [innerHTML]="messageDetails.body"></span>
				</div>
				@if (messageDetails.photos.length > 0) {
					<div class="photos">
						{{messageDetails.photos.length}} Photo(s)
						<div class="display-wrapper">
							@for (photo of messageDetails.photos; track photo) {
							<div class="photo">
								@if (photo.type === 'IMAGE') {
								<img class="image" src="{{photo.url}}">
								}
							</div>
							}
						</div>
					</div>
				}
			</div>
		}
		@if (selectedPage ==='HISTORY') {
			<jhm-table
                [repository]="messageRepository"
                (cellClicked)="cellClicked($event)">
			</jhm-table>
		}
		</div>
	}
</div>